<template>
    <form method="POST" action="/password/reset" @submit.prevent="resetPassword" class="wd-100p">
        <!-- <alert-success :form="form" message="We have e-mailed your password reset link!"></alert-success> -->

        <div class="form-group">
            <label for="password">New Password</label>
            <input v-model="form.password" type="password" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('password') }" name="password" placeholder="Enter your new password" required autofocus>
            <has-error :form="form" field="password"></has-error>
        </div>

        <div class="form-group">
            <label for="password_confirmation">Confirm Password</label>
            <input v-model="form.password_confirmation" type="password" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('password_confirmation') }" name="password_confirmation" placeholder="Type password again" required>
            <has-error :form="form" field="password_confirmation"></has-error>
        </div>

        <button-component :busy="form.busy" :label="'Change Password'" :label-loading="'Please wait...'" :button-class="'btn btn-default btn-block'"></button-component>
    </form>
</template>

<script>
	export default {
		data: function () {
			return {
				form: new Form({
					email: this.$route.query.email,
					phone: this.$route.query.phone,
					country_code: this.$route.query.country_code,
					token: this.$route.params.token,
					password: null,
					password_confirmation: null,
				}),
			};
		},
		methods: {
			resetPassword() {
				this.form.post("/password/reset").then(({ data }) => {
					window.location = data.intended;
				})
				.catch(() => {
					this.error = this.form.errors.get("error");
				});
			},
		},
	};
</script>
